import { render, staticRenderFns } from "./DetailsCar.vue?vue&type=template&id=48d39d67&scoped=true&"
import script from "./DetailsCar.vue?vue&type=script&lang=ts&"
export * from "./DetailsCar.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsCar.vue?vue&type=style&index=0&id=48d39d67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d39d67",
  null
  
)

export default component.exports